import { Dispatch, SetStateAction, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVertFilledIcon } from '../../../assets/icons/icons';
import { OperationActivity, OperationIncidentNote } from '../../../networkRequest/operationsService';

interface ActivityMenuProps {
  loading?: boolean;
  item: OperationActivity | OperationIncidentNote;
  setSelectedItem: Dispatch<SetStateAction<any | null>>;
  onEdit: () => void;
  onDelete: () => void;
}

const ActivityMenu = ({
  loading = false,
  item,
  onEdit,
  onDelete,
  setSelectedItem,
}: ActivityMenuProps) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handleDelete = () => {
    setSelectedItem(item);
    onDelete();
    setMenuAnchorEl(null);
  };

  const handleEdit = () => {
    setSelectedItem(item);
    onEdit();
    setMenuAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={(e) => setMenuAnchorEl(e.currentTarget)}
        aria-label="More options"
        sx={{
          width: 24,
          height: 24,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <MoreVertFilledIcon />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleEdit} disabled={loading}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} disabled={loading}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

export default ActivityMenu;